
const getDecorationLowList = (decorationList) => {
    const mappedList = decorationList.map(item => {
        const lowWidth = Math.floor(item.width / 6)
        const lowHeight = Math.floor(item.height / 6)
        return { ...item, width: lowWidth, height: lowHeight };
    })
    return mappedList
}

export {
    getDecorationLowList
}